import type { Changelog } from "@productlane/zero"

type OrderableChangelog = Pick<Changelog, "published" | "date" | "createdAt">

const timestampOf = (changelog: OrderableChangelog) =>
	new Date(changelog.date || changelog.createdAt).getTime()

export const compareChangelogsForNav = (
	a: OrderableChangelog,
	b: OrderableChangelog,
) => {
	if (a.published !== b.published) return a.published ? 1 : -1
	return timestampOf(b) - timestampOf(a)
}

export const sortChangelogsForNav = <T extends OrderableChangelog>(
	changelogs: readonly T[],
) => [...changelogs].sort(compareChangelogsForNav)

// The public slug is date + title, so the date has to land before the email and
// Slack broadcasts build their links.
export const changelogPublishDate = (id: string, now = Date.now()) => ({
	id,
	date: now,
})

export const changelogPublishFlag = (id: string) => ({ id, published: true })
